import React from 'react';

interface ProgressBarProps {
  step: number;
  total: number;
  subtitle: string;
}

function CustomProgressBar({ step, total, subtitle }: ProgressBarProps) {
  const getStep = () => {
    if (step > total) return total;
    if (step <= 0) return 1;
    return step;
  };

  const percent = total > 0 ? Math.round((getStep() / total) * 100) : 0;

  return (
    <div>
      <div className="px-4 py-4 bg-primary/10 text-xs rounded-t-lg font-sans">
        Passo {getStep()} de {total}:
        <span className="font-bold text-primary ml-2.5">{subtitle}</span>
      </div>
      <progress
        value={percent}
        max={100}
        className="w-full h-1.5 block rounded-b-lg [&::-webkit-progress-bar]:bg-neutral-light [&::-webkit-progress-bar]:rounded-b-lg [&::-webkit-progress-value]:bg-primary [&::-moz-progress-bar]:bg-primary"
      />
    </div>
  );
}

export default CustomProgressBar;
